import { render, staticRenderFns } from "./PreferencesFooter.vue?vue&type=template&id=f9e08c46&"
import script from "./PreferencesFooter.vue?vue&type=script&lang=ts&"
export * from "./PreferencesFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports